'use client';

import { $duration, $show, setShow } from '@trwl/store';
import { useUnit } from 'effector-react';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';

export const Loader = () => {
  const [show, duration] = useUnit([$show, $duration]);

  useEffect(() => {
    const validDuration = Math.max(duration, 0);
    const timeout = setTimeout(() => {
      setShow(false);
    }, validDuration);
    return () => clearTimeout(timeout);
  }, [duration, show]);

  if (!show) return null;
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed select-none bg-white w-[100%] h-[100dvh] flex z-[10000000] justify-center items-center"
          initial={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
        >
          <p
            className="text-[#A9D0CD] text-[72px] motion-safe:animate-pulse font-[600]"
            style={{
              fontStretch: 'expanded',
            }}
          >
            trwl
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
